export const TOGGLE_STATE = {
  MY_ITEMS: "my-items",
  SHARED_ITEMS: "shared-items",
  HIDDEN: "hidden",
};

export enum CurrentViewMorePage {
  Sessions = "sessions",
  Internships = "internships",
  Programs = "programs",
  Housing = "housing",
  Events = "events",
}

// Expand this list to include other libraries as we roll out the is_shared_with filter
export const LIBRARIES_USING_IS_SHARED_WITH: CurrentViewMorePage[] = [CurrentViewMorePage.Sessions];
